// Dashboard Section Header component
export const SectionHeader  = ({ title, description }: { title: string; description: string }) => {
    return (
        <div className="flex items-center gap-3">
            <div>
                <h3 className="text-base font-semibold text-foreground">{title}</h3>
                <p className="text-xs text-muted-foreground mt-0.5">{description}</p>
            </div>
        </div>
    )
}